<template>
  <van-popup v-model="options.show" :style="{ width: '86%' }">
    <van-field
      v-model="value"
      ref="value"
      center
      clearable
      :placeholder="options.placeholder || '请选择或者输入'"
      @keyup.enter="selectItem(value)"
    >
      <template #button>
        <van-button size="small" type="primary" @click="selectItem(value)">确定</van-button>
      </template>
    </van-field>
    <div class="select-box">
      <div class="select-item ellipsis" v-for="(it,i) in cacheList" :key="i" @click="selectItem(it)">
        {{it}}<van-icon name="cross" @click.stop="spliceItem(it)" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from "vant";
export default {
  props: {
    options: {
      type: Object,
      default: {
        show: false,
        key: "",
        placeholder: "请选择或者输入",
        value: ""
      }
    }
  },
  data(){
    return {
      value: "",
      cacheList: []
    }
  },
  watch: {
    'options.show'(val){
      if(!val)return true
      this.cacheList = this.mixGetCache('cache|' + this.options.key, [])
      this.value = this.options.value
      this.$nextTick(_=>{
        this.$refs.value.focus()

      })
    }
  },
  methods: {
    selectItem(val){
      if(val.trim() == "")return Toast("不能输入空白字符")
      let cacheList = this.cacheList
      const findIndex = cacheList.findIndex(it => it == val)
      findIndex != -1 && cacheList.splice(findIndex, 1);
      cacheList.unshift(val)
      cacheList.splice(10)
      this.mixSetCache("cache|" + this.options.key, cacheList)
      this.$emit('selectVal', {val, key: this.options.key})
    },
    spliceItem(val){
      let cacheList = this.cacheList
      const findIndex = cacheList.findIndex(it => it == val)
      cacheList.splice(findIndex, 1)
      this.cacheList = cacheList
      this.mixSetCache("cache|" + this.options.key, cacheList)
    }
  }
}
</script>

<style lang="scss" scoped>

.select-box{
  display: flex;
  flex-wrap: wrap;
}
.select-item{
  padding: 4px 0;
  width: 100%;
  text-align: center;
  padding-right: 4vw;
  padding-left: 2vw;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: calc(10% / 6);
  position: relative;
  box-sizing: border-box;
  & ::v-deep .van-icon-cross{
    position: absolute;
    right: 1vw;
    &::after{
      content: "";
      position: absolute;
      top: -10px;
      left: -10px;
      width: calc(100% + 20px);
      height: calc(100% + 20px);
    }
  }
}
.select-item:active{
  opacity: 0.5;
}

::v-deep .van-popup{
  border-radius: 4px;
  overflow: hidden;
}
</style>